// Quantity discount tiers
export const QUANTITY_DISCOUNTS = [
  { minQuantity: 5, percentage: 10, label: "10% off for 5+ courses" },
  { minQuantity: 4, percentage: 5, label: "5% off for 4+ courses" },
];

/**
 * Calculate quantity discount based on cart size
 * @param {number} quantity - Number of items in cart
 * @param {number} subtotal - Cart subtotal before discount
 * @returns {{ percentage: number, amount: number, label: string }}
 */
export function calculateQuantityDiscount(quantity, subtotal) {
  for (const tier of QUANTITY_DISCOUNTS) {
    if (quantity >= tier.minQuantity) {
      const amount = (subtotal * tier.percentage) / 100;
      return {
        percentage: tier.percentage,
        amount,
        label: tier.label,
      };
    }
  }
  return { percentage: 0, amount: 0, label: "" };
}

/**
 * Calculate discount code discount amount
 * @param {object} discountInfo - Discount validation info from backend
 * @param {number} subtotal - Cart subtotal
 * @returns {number} - Discount amount
 */
export function calculateDiscountCodeAmount(discountInfo, subtotal) {
  if (!discountInfo || !discountInfo.discount_type) return 0;

  if (discountInfo.discount_type === "percentage") {
    return (subtotal * discountInfo.discount_value) / 100;
  } else if (discountInfo.discount_type === "fixed") {
    // Fixed discount, but not more than subtotal
    return Math.min(discountInfo.discount_value, subtotal);
  }
  return 0;
}

/**
 * Get total discount breakdown
 * @param {number} subtotal - Cart subtotal
 * @param {number} quantity - Number of items
 * @param {object} discountInfo - Applied discount code info
 * @returns {{ quantityDiscount, codeDiscount, totalDiscount }}
 */
export function getDiscountBreakdown(subtotal, quantity, discountInfo) {
  const quantityDiscount = calculateQuantityDiscount(quantity, subtotal);
  const codeDiscountAmount = calculateDiscountCodeAmount(
    discountInfo,
    subtotal,
  );

  return {
    quantityDiscount: quantityDiscount.amount,
    quantityDiscountLabel: quantityDiscount.label,
    codeDiscount: codeDiscountAmount,
    totalDiscount: quantityDiscount.amount + codeDiscountAmount,
  };
}
